export enum UiValidatorType {
  NOT_NULL = 'NOT_NULL',
  MIN = 'MIN',
  MAX = 'MAX',
  MIN_LENGTH = 'MIN_LENGTH',
}
